export default __webpack_public_path__ + "static/media/(37).3dcbd887.jpg";